var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M3 22.5A1.5 1.5 0 0 0 4.5 24h15a1.5 1.5 0 0 0 1.5-1.5V18H3zm14.25-18a.75.75 0 0 1-.75-.75V0h-12A1.5 1.5 0 0 0 3 1.5v9h18v-6z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5H21v-.215a.84.84 0 0 0-.246-.594L17.312.246A.84.84 0 0 0 16.714 0H16.5v3.75a.75.75 0 0 0 .75.75M21 9v1.5H3V9a3 3 0 0 0-3 3v5.25a.75.75 0 0 0 .75.75h22.5a.75.75 0 0 0 .75-.75V12a3 3 0 0 0-3-3m-.75 6.375a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25"
  }))));
};
export default SvgPrint;